import { call, put, takeLatest } from 'redux-saga/effects';
import { versionsService } from './versions.service';
import { GET_PUBLISHED_VERSIONS, GET_PUBLISHED_VERSIONS_SUCCESS } from './versions.types';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';

function* getPublishedVersions({ type }) {
    yield put(httpRequestsOnLoadActions.appendLoading(type));
    yield put(httpRequestsOnErrorsActions.removeError(type));
    try {
        const res = yield call(versionsService.getPublishedVersions);
        yield put({
            type: GET_PUBLISHED_VERSIONS_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        const error = err?.data?.message ? err?.data?.message : err?.response?.data?.message;
        yield put(httpRequestsOnErrorsActions.appendError(type, error));
    } finally {
        yield put(httpRequestsOnLoadActions.removeLoading(type));
    }
}

export const watchVersions = function* watchVersionsSaga() {
    yield takeLatest(GET_PUBLISHED_VERSIONS, getPublishedVersions);
};
